<kendo-tabstrip
  [animate]="false"
  #tabstrip
  (tabSelect)="this.selectedContentType.set($event.index)"
>
  <kendo-tabstrip-tab
    title="Projektzeit"
    [selected]="this.selectedContentType() === TimeBlockContentType.Project"
  >
    <ng-template kendoTabContent>
      <app-project-type-dialog
        [workTimeStart]="workTimeStart()"
        [workTimeEnd]="workTimeEnd()"
        [noProjects]="noProjects()"
        (noProjectsChange)="noProjects.set($event)"
        [selectedTimeBlock]="selectedTimeBlockComponent()"
        [footer]="footer"
        [isInvoiced]="isInvoiced()"
        [(projectTypeForm)]="dialogForm"
        [(fixIntervalDropdownVisible)]="fixIntervalDropdownVisible"
        (loading$)="loading.set($event)"
      >
      </app-project-type-dialog>
    </ng-template>
  </kendo-tabstrip-tab>

  @let isActive = selectedTimeBlockComponent().timeBlockModel.isActive;
  <kendo-tabstrip-tab
    title="Abwesenheitszeit"
    [selected]="this.selectedContentType() === TimeBlockContentType.Absence"
    [disabled]="isInvoiced() || isActive"
  >
    <ng-template kendoTabContent>
      <app-absence-type-dialog
        [workTimeStart]="workTimeStart()"
        [workTimeEnd]="workTimeEnd()"
        [selectedTimeBlock]="selectedTimeBlockComponent()"
        [footer]="footer"
        [(absenceTypeForm)]="dialogForm"
        [timeOfDaySelectable]="false"
        [(fixIntervalDropdownVisible)]="fixIntervalDropdownVisible"
      >
      </app-absence-type-dialog>
    </ng-template>
  </kendo-tabstrip-tab>

  <ng-template #footer>
    <footer class="k-d-flex k-justify-content-between">
      <div>
        <button
          (click)="cancel()"
          kendoButton
          size="large"
          themeColor="secondary"
          class="k-mr-4 !k-pr-4"
        >
          <span class="custom-symbol close k-mr-3"></span>
          Schließen
        </button>
        <button
          (click)="sendAction(UserOperation.Delete)"
          [disabled]="!deleteButtonEnabled()"
          kendoButton
          themeColor="error"
          class="!k-pr-4"
          size="large"
        >
          <span class="custom-symbol delete k-mr-3 red"></span>
          Löschen
        </button>
      </div>
      <div>
        <button
          kendoButton
          [disabled]="!updateButtonEnabled()"
          (click)="
            sendAction(
              selectedTimeBlockComponent().id >= 0 ? UserOperation.Update : UserOperation.Create
            )
          "
          themeColor="base"
          class="!k-pr-4"
          size="large"
        >
          <span class="custom-symbol save k-mr-3"></span>
          {{ selectedTimeBlockComponent().id >= 0 ? "Aktualisieren" : "Speichern" }}
        </button>
      </div>
    </footer>
  </ng-template>
</kendo-tabstrip>
